import type {BilingualStringList} from '../../../../../types/shared-types';
import {WorkforceProfileCulturalFitPillarDescription} from '../../types/WorkforceProfileTypes';

export const getLocalizedList = (list: BilingualStringList, language: 'en' | 'de'): string[] => {
  const primary = list[language];

  if (primary.length > 0) {
    return primary;
  }

  return list[language === 'de' ? 'en' : 'de'];
};

export interface PillarDetailSection {
  key: string;
  label: string;
  items: string[];
}

export interface PillarDetailSectionLabels {
  evaluations: string;
  opportunities: string;
  risks: string;
  whatToLookFor: string;
  interviewQuestions: string;
}

export const buildPillarDetailSections = (
  pillar: WorkforceProfileCulturalFitPillarDescription,
  language: 'en' | 'de',
  labels: PillarDetailSectionLabels
): PillarDetailSection[] =>
  [
    {key: 'evaluations', label: labels.evaluations, items: getLocalizedList(pillar.evaluations, language)},
    {key: 'opportunities', label: labels.opportunities, items: getLocalizedList(pillar.opportunities, language)},
    {key: 'risks', label: labels.risks, items: getLocalizedList(pillar.risks, language)},
    {key: 'whatToLookFor', label: labels.whatToLookFor, items: getLocalizedList(pillar.whatToLookFor, language)},
    {
      key: 'interviewQuestions',
      label: labels.interviewQuestions,
      items: getLocalizedList(pillar.interviewQuestions, language),
    },
  ].filter((section) => section.items.length > 0);
